import { render } from "./IconCanceledByInmarsat.vue?vue&type=template&id=b393c682"
import script from "./IconCanceledByInmarsat.vue?vue&type=script&lang=js"
export * from "./IconCanceledByInmarsat.vue?vue&type=script&lang=js"
script.render = render

export default script